import ActivateDeactivateButton from "@app/components/activate-deactivate-button.tsx";
import ActivateDeactivateIndicator from "@app/components/activate-deactivate-indicator.tsx";
import ActiveIndicator from "@app/components/active-indicator.tsx";
import { StaffingModel } from "@app/data/engine.ts";
import EditIcon from "@mui/icons-material/Edit";
import PasswordIcon from "@mui/icons-material/Password";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    isAdmin: boolean;
    onEdit: (id: number) => void;
    onDelete: (id: number) => void;
    onRestore: (id: number) => void;
    onChangePassword: (id: number) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<StaffingModel>();
export const staffingTableDefinition = ({
    isAdmin,
    onEdit,
    onDelete,
    onRestore,
    onChangePassword,
    rowCount,
}: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Box display={"flex"}>
                <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original.staffingId!)}>
                    <EditIcon />
                </IconButton>
                {isAdmin && (
                    <IconButton
                        tooltip={"Change Password"}
                        onClick={() => onChangePassword(item.row.original.staffingId!)}
                    >
                        <PasswordIcon />
                    </IconButton>
                )}
            </Box>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.lastName, { id: "lastName", header: "Last Name" }),
    columnHelper.accessor((x) => x.firstName, { id: "firstName", header: "First Name" }),
    columnHelper.accessor((x) => x.roleName, { id: "role", header: "Role" }),
    columnHelper.accessor((x) => x.email, { id: "email", header: "Email" }),
    columnHelper.accessor((x) => x.active, {
        id: "active",
        name: "Active",
        header: () => (
            <Box display={"flex"} alignItems={"center"} gap={2}>
                Active
                <ActivateDeactivateIndicator />
            </Box>
        ),
        cell: (item) => (
            <ActivateDeactivateButton
                isActive={item.getValue() ?? false}
                onDeactivate={() => onDelete(item.row.original.staffingId!)}
                onActivate={() => onRestore(item.row.original.staffingId!)}
            />
        ),
    }),
    columnHelper.accessor((x) => x.isHourly, {
        id: "hourly",
        header: "Hourly",
        cell: (item) => <ActiveIndicator isActive={item.getValue() ?? false} />,
    }),
];
